module.exports = __webpack_public_path__ + "d0004ac9bea3ac20f36834f3be12b5b0.svg";